

// Padbol Match frontend entry point.
import './utils/ignoreResizeObserver';
import React from 'react';
import ReactDOM from 'react-dom/client';
/** i18n antes de App: init + react-i18next (useSuspense: false en ./i18n/index.js). */
import './i18n';
import './index.css';
import './components/torneo/NationsCupPanel.css';
import './styles/TournamentParticipants.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { PadbolI18nProvider } from './context/PadbolI18nContext';
import { ThemeProvider } from './context/ThemeContext';
import { registerServiceWorker } from './registerServiceWorker';

// Diagnostico de push: registra en el servidor el estado real del dispositivo
// (permiso, service worker y si existe suscripcion) para saber por que no llega.
try {
  const enviar = (detail) => import('./supabaseClient').then(({ supabase }) => {
    supabase.from('app_launch_events').insert({ path: '/push-diag', mode: 'diag', detail }).then(() => {}, () => {});
  }).catch(() => {});
  const base = { permission: typeof Notification !== 'undefined' ? Notification.permission : 'sin-api',
    standalone: window.navigator.standalone === true, sw: 'serviceWorker' in navigator,
    pushManager: 'PushManager' in window };
  if (base.sw) {
    navigator.serviceWorker.getRegistration().then(async (reg) => {
      let sub = null;
      try { sub = reg ? await reg.pushManager.getSubscription() : null; } catch (e) { base.error = String((e && e.name) || e); }
      enviar({ ...base, registro: Boolean(reg), activo: Boolean(reg && reg.active), suscripcion: Boolean(sub), endpoint: sub ? new URL(sub.endpoint).host : null });
    }).catch((e) => enviar({ ...base, error: String((e && e.name) || e) }));
  } else { enviar(base); }
} catch { /* ignore */ }


// Telemetria minima de arranque: registra en el servidor la ruta inicial y el
// modo (app instalada o navegador). Sin datos personales ni credenciales.
try {
  const mod = window.navigator.standalone === true ? 'app' : 'navegador';
  // Si la app arranco en el CRM, queda marcada en ESTE contexto (la app instalada
  // tiene su propio almacenamiento, distinto del de Safari).
  if (window.location.pathname.startsWith('/crm')) {
    try { localStorage.setItem('padbol_crm_app', '1'); } catch { /* ignore */ }
  }
  const payload = { path: window.location.pathname.slice(0, 120), mode: mod,
    referrer: String(document.referrer || '').slice(0, 120) || null };
  import('./supabaseClient').then(({ supabase }) => {
    supabase.from('app_launch_events').insert(payload).then(() => {}, () => {});
  }).catch(() => {});
} catch { /* ignore */ }





// PADBOL CRM instalado en la pantalla de inicio: iOS arranca la app en la raiz
// ('/') porque el manifest con el que se instalo tenia start_url '/'. No hay
// storage compartido entre Safari y la app instalada, asi que la unica marca
// confiable es el modo standalone. Si la app instalada abre en la raiz, se va
// al CRM. El panel de administracion sigue accesible en /admin.
if (typeof window !== 'undefined' && window.navigator.standalone === true
  && (window.location.pathname === '/' || window.location.pathname === '')) {
  window.location.replace('/crm-leads');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <PadbolI18nProvider>
          <App />
        </PadbolI18nProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

registerServiceWorker();

// Actualizacion automatica de la app instalada: al abrir, busca una version
// nueva del service worker y recarga una sola vez cuando toma el control.
// Evita que un iPhone quede semanas con un bundle viejo en la pantalla de inicio.
if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
  let recargando = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (recargando) return;
    recargando = true;
    window.location.reload();
  });
  navigator.serviceWorker.getRegistration()
    .then((reg) => reg && reg.update())
    .catch(() => {});
}
